export const APP_VERSION = "2026.08.27";
export default APP_VERSION;
